import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

/**
 * Standalone-Komponente für den MSAL-Redirect-Callback.
 * Muss auf einer Route ohne authGuard registriert sein (z. B. /auth).
 * Verarbeitet den Authorization-Code von Microsoft und
 * leitet danach zur ursprünglich angeforderten Seite weiter.
 */
@Component({
  standalone: true,
  selector: 'app-auth-redirect',
  template: '',
})
export class AuthRedirectComponent implements OnInit {
  private readonly msalService = inject(MsalService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.msalService.instance
      .handleRedirectPromise()
      .then((result) => {
        if (result?.account) {
          this.msalService.instance.setActiveAccount(result.account);
        }
        // Zur ursprünglichen Seite navigieren (MSAL speichert sie intern)
        // Fallback: Projektliste
        const loginRequestUrl =
          sessionStorage.getItem('msal.interaction.status') ?? null;
        void this.router.navigateByUrl(loginRequestUrl ?? '/qs/projects');
      })
      .catch((err) => {
        console.error('[AuthRedirect] handleRedirectPromise Fehler:', err);
        void this.router.navigate(['/qs/projects']);
      });
  }
}

